import React from 'react';
import TextInput from '../../../components/forms/TextInput';
import SelectInput from '../../../components/forms/SelectInput';
import PasswordInput from '../../../components/forms/PasswordInput';

function UserSignupForm({ register, errors }) {
  return (
    <div className=''>
      <TextInput
        label="First Name"
        name="first_name"
        type="text"
        placeholder="John"
        register={register}
        errors={errors}
        validationRules={{ required: 'First name is required' }}
      />
      <TextInput
        label="Last Name"
        name="last_name"
        type="text"
        placeholder="Doe"
        register={register}
        errors={errors}
        validationRules={{ required: 'Last name is required' }}
      />
      <TextInput
        label="Email"
        name="email"
        type="email"
        placeholder="john.doe@example.com"
        register={register}
        errors={errors}
        validationRules={{ required: 'Email is required' }}
      />
      <PasswordInput 
        label="Password"
        name="password"
        register={register}
        errors={errors}
        placeholder="********"
        validationRules={{ 
          required: 'Password is required',
          minLength: { value: 8, message: 'Password must be at least 8 characters' },
          validate: (value) => {
            if (!/[A-Z]/.test(value)) {
              return 'Must contain at least one uppercase letter';
            }
            if (!/[a-z]/.test(value)) {
              return 'Must contain at least one lowercase letter';
            }
            if (!/\d/.test(value)) {
              return 'Must contain at least one number';
            }
            return true;
          }
        }}
      />
      <SelectInput
        label="Gender"
        name="gender"
        register={register}
        errors={errors}
        options={[
          { value: 'MALE', label: 'Male' },
          { value: 'FEMALE', label: 'Female' },
        ]}
        validationRules={{ required: 'Gender is required' }}
      />
    </div>
  );
}

export default UserSignupForm;